<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction" />
        <form>
            <div class="inner">
                <add-button v-if="$_createActionAllowed" :title="'Přidat plátce' | translate" route-name="billerNew" />
                <h1 v-translate>Plátci</h1>
            </div>
            <div class="inner_white">
                <div class="filter search_only">
                    <div class="field_left">
                        <search-input input-class="search" v-model="formFields.search" />
                    </div>
                  <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
                </div>
              <form>
                <div class="scroll-wrapper">
                  <div class="table_overflow" id="contentBox" data-table-id="billers-list">
                    <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                      <thead>
                      <tr v-if="entities.length > 0">
                        <th class="no_padding drag_drop"></th>
                        <th class="no_padding checkbox"></th>
                        <sorting-table-title
                            v-for="title in sortingTableTitles"
                            :key="title.id"
                            :column="title.column"
                            :sort="getActiveSort(title.column)"
                            @changeSorting="changeSorting"
                        >{{ title.name }}
                        </sorting-table-title>
                        <th class="no_padding edit"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <biller-row
                          v-for="entity in entities"
                          :entity="entity"
                          :key="entity.id"
                          :selectedEntities="selectedEntities"
                          @input="select"
                          @updateEntity="updateEntity"
                          @deleteEntity="deleteEntity"
                      ></biller-row>
                      <tr v-if="entities.length === 0">
                        <td colspan="8">{{ $gettext('Nebyli nalezeni žádní plátci.') }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <list-action-line
                    :entities="entities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                    :total-count="totalCount"
                    table-id="billers-list"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    @limit="setLimit"
                    @offset="setOffset"
                    ref="action_line"
                ></list-action-line>
              </form>
            </div>
        </form>
    </div>
</template>

<script>
	import BillerRow from "@/components/views/billers/BillerRow"
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "BillerList",
		components: {BillerRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'billers',
				tags: [],
			}
		},
    computed: {
      multipleActionOptions() {
          let options = [
              {value: 'choose', text: this.$gettext('Vyberte akci')},
              {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
          ]
        if(this.$_deleteActionAllowed){
          options.push({value: 'delete', text: this.$gettext('Smazat')});
        }

        return options;
      },
      sortingTableTitles() {
          return [
              {id: 1, name: this.$gettext('Příjmení jméno'), column: 'sSurname'},
              {id: 2, name: this.$gettext('Společnost'), column: 'sCompany'},
              {id: 3, name: this.$gettext('Operátor'), column: 'sOperatorName'},
              {id: 4, name: this.$gettext('Město'), column: 'sTown'},
              {id: 5, name: this.$gettext('Počet odběratelů'), column: 'sSubscribersCount'},
              {id: 6, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
              {id: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
          ]
      },
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
        headers.surname.callback = (entity) => {return entity.surname + ' ' + entity.firstname; };
        headers.company.callback = (entity) => {return entity.company_name ? entity.company_name : ''};
        headers.town.callback = (entity) => {return entity.address.town ? entity.address.town: ''};

        return headers;
      },
    },
		created(BillerService) {
      this.entityService = BillerService
			this.createdInit()
    },
		methods: {
			_processListErrorMessage(error) {
				let deleteError = null
				this._.forEach(error['validation_errors'], function (errorMessage) {
					if (this._.includes(errorMessage, 'Unable to delete Biller') &&
						this._.includes(errorMessage, 'subscribers with given biller')) {
						deleteError = this.$gettext('Není možné smazat plátce pokud je přiřazen k odběrateli.')
					}
				}.bind(this))

				return deleteError || error['error_message']
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/billers/BillerList.vue